import { render, staticRenderFns } from "./CanteenInfoWidget.vue?vue&type=template&id=045eb984&"
import script from "./CanteenInfoWidget.vue?vue&type=script&lang=js&"
export * from "./CanteenInfoWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports